import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import SearchReducer from "./reducers/SearchReducer";
import TicketsReducer from "./reducers/TicketsReducer";
import UserReducer from "./reducers/UserReducer";

const rootReducer = combineReducers({
  user: UserReducer,
  tickets: TicketsReducer,
  search: SearchReducer
})

let store = createStore(rootReducer, applyMiddleware(thunk, logger));

export default store;